import {Component} from '@angular/core';
import {TranslateService as TranslateProvider} from '@ngx-translate/core';
import {AnalyticsConfiguration, AnalyticsService, APP_CONFIG, TranslateService} from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-root',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class AppComponent {
    title: string = 'core-archipelago';

    constructor(
        private translate: TranslateService,
        private translateProvider: TranslateProvider,
        private analytics: AnalyticsService,
    ) {
        this.analytics.initialise(<AnalyticsConfiguration>{
            gtm: {id: APP_CONFIG.gtm, consent: 3},
        });

        if (APP_CONFIG.multilingual) {
            this.translateProvider.setDefaultLang(translate.getDefaultLanguage());
            this.translate.getLanguages().subscribe((languages: any) => {
                this.translateProvider.addLangs(
                    languages.map((language: any) => {
                        return language.code;
                    })
                );
            });
        }
    }

}
